import {useEffect, useRef, useState} from "react";

function SurNameInput(props){

    const input = useRef();
    const [error, setError] = useState(true)
    const [showError, setShowError] = useState(false)

    const validateHandler = () => {
        props.value(false);
        switch(true) {
            case (input.current.value.length === 0):
                setError("Please enter your surname")
                return
            case (!input.current.value.replace(/\s/g, '').length):
                setError("Please enter your surname")
                return
            case (input.current.value.length > 50):
                setError("Please enter a surname under 50 characters")
                return
            default:
                setError(false);
                setShowError(false);
                props.value(input.current.value);
                return
        }
    }

    const showErrorHandler = () => {
        validateHandler()
        setShowError(true)
    }

    useEffect(() => {
        if(props.forceValidation){
            showErrorHandler();
        }
    })

    return(
        <>
            <label htmlFor="SurName" className={"label"}>{props.label}:</label>
            {(error && showError) && <div className={"bubble"}>{error}</div>}
            <input
                defaultValue={props.defaultValue}
                ref={input}
                type="text"
                name="SurName"
                autoComplete="family-name"
                maxLength={50}
                onBlur={showErrorHandler}
                onChange={validateHandler}
                className={"input"}
                disabled={props.sending}
            />
        </>
    )
}

export default SurNameInput;